import './rollbar';
import "@hotwired/turbo-rails";
import "@37signals/lexxy";
import "./controllers";
import * as bootstrap from "bootstrap";

// Initialize Bootstrap tooltips after Turbo navigation (also fires on initial page load)
document.addEventListener("turbo:load", () => {
  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el));

  // Ensure mobile nav collapses when resizing up to desktop widths.
  const collapseEl = document.getElementById("siteNavbar");
  if (collapseEl) {
    const bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapseEl, {
      toggle: false,
    });

    const maybeClose = () => {
      if (window.innerWidth >= 992) {
        bsCollapse.hide();
      }
    };

    window.addEventListener("resize", maybeClose);
    maybeClose();
  }
});
